module.exports = __webpack_public_path__ + "static/img/p9.fcf887e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p9.png
// module id = 251
// module chunks = 1